import { render } from "./SettingsComp.vue?vue&type=template&id=5aa243be&scoped=true"
import script from "./SettingsComp.vue?vue&type=script&lang=js"
export * from "./SettingsComp.vue?vue&type=script&lang=js"

import "./SettingsComp.vue?vue&type=style&index=0&id=5aa243be&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aa243be"]])

export default __exports__